import { setSession, clearSession, setSessionLoading, setSessionError } from "./sessionSlice";
import { setCompanyInfo, clearCompanyInfo } from "./executorSlice";

/**
 * Unified setCredentials action/thunk
 * Dispatches both session (settings.userInfo) and executor (companyInfo)
 */
export const setCredentials = (payload) => (dispatch) => {
  const {
    token,
    user,
    userInfo,
    id,
    companyCode,
    companyName,
    companyAddress,
    role,
    callStatus,
    leadStatuses,
  } = payload || {};

  const resolvedUser = userInfo || user || {};
  const mergedUser = {
    ...resolvedUser,
    id: id || resolvedUser.id || resolvedUser._id,
    companyCode: companyCode || resolvedUser.companyCode,
    companyName: companyName || resolvedUser.companyName,
    companyAddress: companyAddress || resolvedUser.companyAddress,
    role: role || resolvedUser.role || "company_admin",
  };

  dispatch(
    setSession({
      token,
      userInfo: mergedUser,
    })
  );

  dispatch(
    setCompanyInfo({
      companyCode: mergedUser.companyCode,
      companyName: mergedUser.companyName,
      companyAddress: mergedUser.companyAddress,
      callStatus: callStatus || leadStatuses || mergedUser.leadStatuses || mergedUser.callStatus,
    })
  );
};

/**
 * Unified logout action/thunk
 */
export const logout = () => (dispatch) => {
  dispatch(clearSession());
  dispatch(clearCompanyInfo());
};

export const setLoading = (loading) => (dispatch) => {
  dispatch(setSessionLoading(loading));
};

export const setError = (error) => (dispatch) => {
  dispatch(setSessionError(error));
};

export default function authReducer(state = {}, action) {
  return state;
}
